export default __webpack_public_path__ + "static/media/send-icon.16e122ec.svg";